export default __webpack_public_path__ + "static/media/qhqn.e6055d96.png";